module.exports = __webpack_public_path__ + "static/media/mockPoll.f82d506b.webp";